// import JS files
import '../kickstart';
import './sticky-nav-bar';

import { h, render } from 'preact';

// Components
import App from '../ResultsApp';
import loadJsonScript from '../utils/load-json-script';

const notes = loadJsonScript('notes_data');

const annotations = loadJsonScript('annotations_data');

render(
  <App notes={notes} annotations={annotations} />,
  document.getElementById('app')
);
